import store  from  'store'

const userkey = "user-key"
const optimalkey = "optimal-key"
const storage = {
    saveUser(user){
        store.set(userkey,user)
    },
    getUser(){
        return store.get(userkey)
    },
    deleteUser(user){
        store.remove(userkey)
    },   
};
export default storage;
export const PushOptimalDataToStore = (data)=> {
  store.set(optimalkey,data)
};

export const GetOptimalDataFromStore = () => {
  return store.get(optimalkey)
};

const LOCAL_STORAGE_KEY = 'my_app_local_data';

export const saveToLocalStorage = (data) => {
  const existingData = getLocalStorageData();
  const newData = { ...existingData, ...data };
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
};

export const getLocalStorageData = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
  return storedData ? JSON.parse(storedData) : {};
};

export const clearLocalStorageData = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};


const LOCAL_STORAGE_OPTIMAL_DATA = 'my_app_local_optimal_data';

export const saveOptimalDataToLocalStorage = (data) => {
  const existingData = getOptimalDataFromLocalStorage();
  const newData = { ...existingData, ...data };
  localStorage.setItem(LOCAL_STORAGE_OPTIMAL_DATA, JSON.stringify(newData));
};

export const getOptimalDataFromLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_OPTIMAL_DATA);
  return storedData ? JSON.parse(storedData) : {};
};

export const clearOptimalDataFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_OPTIMAL_DATA);
};


const LOCAL_STORAGE_PORTFOLIO_DATA = 'app_local_portfolio_data';

export const savePortfolioDataToLocalStorage = (data) => {
  localStorage.removeItem(LOCAL_STORAGE_PORTFOLIO_DATA);
  localStorage.setItem(LOCAL_STORAGE_PORTFOLIO_DATA, JSON.stringify(data));
};

export const getPortfolioDataFromLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_PORTFOLIO_DATA);
  return storedData ? JSON.parse(storedData) : null;
};

export const clearPortfolioDataFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_PORTFOLIO_DATA);
};



const LOCAL_STORAGE_PORTFOLIO_SETTING = 'app_local_portfolio_setting';

export const savePortfolioSettingToLocalStorage = (data) => {
  localStorage.removeItem(LOCAL_STORAGE_PORTFOLIO_SETTING);
  localStorage.setItem(LOCAL_STORAGE_PORTFOLIO_SETTING, JSON.stringify(data));
};

export const getPortfolioSettingFromLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_PORTFOLIO_SETTING);
  return storedData ? JSON.parse(storedData) : null;
};

export const clearPortfolioSettingFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_PORTFOLIO_SETTING);
};

const LOCAL_STORAGE_LOCALE_NAME = 'TransLocal';

export const saveTransLocalStorage = (data) => {
  localStorage.removeItem(LOCAL_STORAGE_LOCALE_NAME);
  localStorage.setItem(LOCAL_STORAGE_LOCALE_NAME, JSON.stringify(data));
};

export const getTransLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_LOCALE_NAME);
  return storedData ? JSON.parse(storedData) : 'ja';
};



export const saveCommonStorage = (key,data) => {
  localStorage.removeItem(key);
  localStorage.setItem(key, JSON.stringify(data));
};

export const getCommonStorage = (key) => {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : null;
};

export const clearCommonStorage = (key) => {
  localStorage.removeItem(key);
};



const LOCAL_STORAGE_LOGIN_SETTING = 'cloudz_login_user';

export const saveLoginToLocalStorage = (data) => {
  localStorage.removeItem(LOCAL_STORAGE_LOGIN_SETTING);
  localStorage.setItem(LOCAL_STORAGE_LOGIN_SETTING, JSON.stringify(data));
};

export const getLoginFromLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_LOGIN_SETTING);
  return storedData ? JSON.parse(storedData) : {};
};

export const clearLoginFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_LOGIN_SETTING);
};


const LOCAL_STORAGE_DUMMY_SETTING = 'cloudz_dummy_user';

export const saveDummyToLocalStorage = (dummyUserId) => {
  localStorage.removeItem(LOCAL_STORAGE_DUMMY_SETTING);
  localStorage.setItem(LOCAL_STORAGE_DUMMY_SETTING, dummyUserId);
};

export const getDummyFromLocalStorage = () => {
  const storedData = localStorage.getItem(LOCAL_STORAGE_DUMMY_SETTING);
  return storedData ? storedData : '';
};

export const clearDummyFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_DUMMY_SETTING);
};